import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.367 6.644q1.388.084 2.286 1.045.939.918.939 2.507 0 1.88-1.143 2.883-1.143.96-2.694.92-1.061 0-1.837-.419a3.9 3.9 0 0 1-1.224-1.086 5.2 5.2 0 0 1-.735-1.63 9 9 0 0 1-.204-1.922q0-1.546.53-2.967.572-1.42 1.47-2.59a11.5 11.5 0 0 1 2.122-2.048A9.6 9.6 0 0 1 16.328 0q.408.67.816 1.295.45.627.857 1.296-.53.334-1.102.794a9 9 0 0 0-1.102.96q-.49.544-.898 1.129a4.5 4.5 0 0 0-.53 1.17m-9.755 0Q6 6.728 6.898 7.689q.939.918.939 2.507 0 1.88-1.143 2.883-1.143.96-2.735.92-1.02 0-1.796-.419A3.9 3.9 0 0 1 .94 12.494a5.2 5.2 0 0 1-.735-1.63A9 9 0 0 1 0 8.942q0-1.546.53-2.967.572-1.42 1.47-2.59a11.5 11.5 0 0 1 2.122-2.048A9.6 9.6 0 0 1 6.572 0q.408.67.816 1.295.45.627.857 1.296a12 12 0 0 0-1.102.794 9 9 0 0 0-1.102.96q-.49.544-.898 1.129-.368.585-.53 1.17"
    }, null, -1)
  ]))]))
}
export default { render: render }